module.exports = __webpack_public_path__ + "static/media/icon-star-non-primary.a1e334a3.svg";